import { render, staticRenderFns } from "./AgendamentoEnvio.vue?vue&type=template&id=205155e4&"
import script from "./AgendamentoEnvio.vue?vue&type=script&lang=js&"
export * from "./AgendamentoEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports